export { default as RegistroCierreMensualProduccion } from "./RegistroCierreMensualProduccion";
